import { render, staticRenderFns } from "./DetailsImageModal.vue?vue&type=template&id=c1b718c4&scoped=true"
import script from "./DetailsImageModal.vue?vue&type=script&lang=ts"
export * from "./DetailsImageModal.vue?vue&type=script&lang=ts"
import style0 from "./DetailsImageModal.vue?vue&type=style&index=0&id=c1b718c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1b718c4",
  null
  
)

export default component.exports